export const errorTrackerEndpoints = (builder) => ({
  getErrorTracker: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 20,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      if (searchTerm !== null && searchTerm !== undefined && searchTerm !== '') {
        params.searchTerm = searchTerm;
      }

      if (searchValue !== null && searchValue !== undefined && searchValue !== '') {
        params.searchValue = searchValue;
      }

      return {
        url: '/admin/error-tracker/list',
        method: 'GET',
        params,
      };
    },
    transformResponse: (response) => ({
      data: response?.data ?? [],
      totalCount: response?.totalCount ?? 0,
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: ['ErrorTracker'],
  }),
  resolveError: builder.mutation({
    query: ({ id }) => ({
      url: `/admin/error-tracker/${id}/resolve`,
      method: 'POST',
    }),
    invalidatesTags: ['ErrorTracker'],
  }),
});
